import { render, staticRenderFns } from "./PortalAccountsTab.vue?vue&type=template&id=4bf9b362&scoped=true&"
import script from "./PortalAccountsTab.vue?vue&type=script&lang=js&"
export * from "./PortalAccountsTab.vue?vue&type=script&lang=js&"
import style0 from "./PortalAccountsTab.vue?vue&type=style&index=0&id=4bf9b362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf9b362",
  null
  
)

export default component.exports